import {ABusiness} from "@/views/editor/service/business";
import {h} from "vue";
import {TrophyFilled} from "@ant-design/icons-vue";
import {AEditor} from "@/views/editor/service/editor";
import {EActivityStatus, IActivityBusinessMeta} from "@/model/activity";
import {RadioGroupChildOption} from "ant-design-vue/es/radio/Group";
import {CheckboxOptionType} from "ant-design-vue/es/checkbox/interface";

export abstract class ARaffle extends ABusiness {
    readonly icon = () => h(TrophyFilled, {style: 'color:#eab308'});
    readonly title = '抽奖';
    readonly description = '不仅是高效的“流量磁石”，更是低成本获取大量用户信息和品牌曝光的利器。';

    protected constructor(protected readonly editor: AEditor, readonly meta: IActivityBusinessMeta) {
        super(editor, meta);
    }

    implementations(status: EActivityStatus): RadioGroupChildOption[] {
        return {
            active: [{value: 'raffle', label: '抽奖'}],
            preheating: [{value: 'raffle', label: '抽奖'}],
            finished: []
        }[status]
    }

    subs(): CheckboxOptionType[] {
        return []
    }
}